import React from "react";
import "./about.scss";
import cssIcon from "../../assets/css-icon.svg";
import htmlIcon from "../../assets/html-icon.svg";
import jsIcon from "../../assets/js-icon.svg";
import nodeIcon from "../../assets/node-icon.svg";
import vueIcon from "../../assets/vue-icon.svg";
import mongoIcon from "../../assets/mongo.svg";
import laravelIcon from "../../assets/laravel.svg";
import djangoIcon from "../../assets/django.svg";
import postIcon from "../../assets/post.svg";
import mysqlIcon from "../../assets/mysql-icon.svg";
import dockerIcon from "../../assets/docker.svg";
import reactIcon from "../../assets/react-icon.svg";
import reduxIcon from "../../assets/redux.svg";
import python from "../../assets/python.svg";
import typescriptIcon from "../../assets/typescript-icon.svg";
import { AnimationOnScroll } from "react-animation-on-scroll";

const About = () => {
  return (
    <div id="about">
      <div className="main-title">About Me</div>

      <div className="about">
        <img className="about-img " src={"/images/danny.png"} alt="about-img" />
        <div className="about-left">
          <div className="main-subtitle">
            Diligent software engineer with 1+ years of experience in web
            application development and eager to broaden my horizons and work on
            different projects and responsibilities. I'm interested in
            developing innovative initiatives that increase the efficiency and
            performance of organizations. To design trustworthy and
            user-friendly solutions. Experienced in design software that is
            customized to match a company's organizational needs, emphasize
            their core skills, and enhance their success, a confident
            communicator, strategic thinker, and imaginative creator.
          </div>
          <AnimationOnScroll animateIn="fadeInLeft" delay={0.7 * 1000}>
            <h3>Here are some of my skills</h3>
          </AnimationOnScroll>
          <div className="hard-skills">
            <div className="ability">
              <AnimationOnScroll animateIn="fadeInUp" delay={0.6 * 1000}>
                <img src={nodeIcon} alt="Node" />
                <p className="skill-text">Node.js</p>
              </AnimationOnScroll>
            </div>

            <div className="ability">
              <AnimationOnScroll animateIn="fadeInUp" delay={0.6 * 1000}>
                <img src={djangoIcon} alt="Django" />
                <p className="skill-text">Django</p>
              </AnimationOnScroll>
            </div>

            <div className="ability">
              <AnimationOnScroll animateIn="fadeInUp" delay={0.6 * 1000}>
                <img src={laravelIcon} alt="Laravel" />
                <p className="skill-text">Laravel</p>
              </AnimationOnScroll>
            </div>

            <div className="ability">
              <AnimationOnScroll animateIn="fadeInUp" delay={0.6 * 1000}>
                <img src={mongoIcon} alt="Mongo" />
                <p className="skill-text">Mongo</p>
              </AnimationOnScroll>
            </div>

            <div className="ability">
              <AnimationOnScroll animateIn="fadeInUp" delay={0.6 * 1000}>
                <img src={postIcon} alt="Postgresql" />
                <p className="skill-text">Postgresql</p>
              </AnimationOnScroll>
            </div>

            <div className="ability">
              <AnimationOnScroll animateIn="fadeInUp" delay={0.6 * 1000}>
                <img src={mysqlIcon} alt="Mysql" />
                <p className="skill-text">Mysql</p>
              </AnimationOnScroll>
            </div>

            <div className="ability">
              <AnimationOnScroll animateIn="fadeInUp" delay={0.1 * 1000}>
                <img src={reactIcon} alt="React" />
                <p className="skill-text">React.js</p>
              </AnimationOnScroll>
            </div>

            <div className="ability">
              <AnimationOnScroll animateIn="fadeInUp" delay={0.1 * 1000}>
                <img src={reduxIcon} alt="Redux" />
                <p className="skill-text">Redux.js</p>
              </AnimationOnScroll>
            </div>

            <div className="ability">
              <AnimationOnScroll animateIn="fadeInUp" delay={0.2 * 1000}>
                <img src={vueIcon} alt="Vue" />
                <p className="skill-text">Vue.js</p>
              </AnimationOnScroll>
            </div>

            <div className="ability">
              <AnimationOnScroll animateIn="fadeInUp" delay={0.4 * 1000}>
                <img src={htmlIcon} alt="Html" />
                <p className="skill-text">HTML</p>
              </AnimationOnScroll>
            </div>

            <div className="ability">
              <AnimationOnScroll animateIn="fadeInUp" delay={0.5 * 1000}>
                <img src={cssIcon} alt="Css" />
                <p className="skill-text">CSS</p>
              </AnimationOnScroll>
            </div>

            <div className="ability">
              <AnimationOnScroll animateIn="fadeInUp" delay={0.3 * 1000}>
                <img src={jsIcon} alt="JavaScript" />
                <p className="skill-text">JavaScript</p>
              </AnimationOnScroll>
            </div>

            <div className="ability">
              <AnimationOnScroll animateIn="fadeInUp" delay={0.3 * 1000}>
                <img src={python} alt="Python" />
                <p className="skill-text">Python</p>
              </AnimationOnScroll>
            </div>

            <div className="ability">
              <AnimationOnScroll animateIn="fadeInUp" delay={0.7 * 1000}>
                <img src={typescriptIcon} alt="Typescript" />
                <p className="skill-text">Typescript</p>
              </AnimationOnScroll>
            </div>

            <div className="ability">
              <AnimationOnScroll animateIn="fadeInUp" delay={0.7 * 1000}>
                <img src={dockerIcon} alt="Docker" />
                <p className="skill-text">Docker</p>
              </AnimationOnScroll>
            </div>
          </div>
          <a href={"/pdf/dannyResume.pdf"} download>
            <button className="button">Download Resume</button>
          </a>
        </div>
      </div>
    </div>
  );
};

export default About;
